module.exports = __webpack_public_path__ + "static/media/COMP-101-badge.9d526bda.svg";